import { TextField } from "@mui/material";
import { useEffect, useRef } from "react";
import { FieldError } from "react-hook-form";

type Props = {
	value: string;
	onChange: (comment: string) => void;
	fieldError?: FieldError | undefined;
	getValues?: Function;
	disabled?: boolean;
	rows?: { minRows: number; maxRows: number };
	maxLength?: number;
	focusComment?: boolean;
};

export const CommentsField = ({
	value,
	onChange,
	fieldError,
	getValues = () => {},
	disabled = false,
	rows = { minRows: 3, maxRows: 3 },
	maxLength = 200,
	focusComment = false,
}: Props) => {
	const textFieldRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (focusComment && textFieldRef.current) {
			textFieldRef.current.focus();
		}
	}, [focusComment]);

	return (
		<>
			<TextField
				data-test-id="comments"
				label="Comments"
				aria-readonly={disabled}
				size="small"
				fullWidth
				value={value ?? ""}
				maxRows={rows.maxRows}
				minRows={rows.minRows}
				multiline
				autoComplete="off"
				disabled={disabled}
				inputRef={textFieldRef}
				onChange={(event) => {
					if (event.target.value.length <= maxLength) {
						onChange(event.target.value);
					}
				}}
				error={!!fieldError}
				helperText={fieldError?.message}
				slotProps={{
					htmlInput: { "data-test-id": "comments-input" },
				}}
			/>
			{((getValues("Comments") || value)?.length as number) !== maxLength && (
				<span style={{ marginLeft: 5, fontSize: 12, color: "#757575" }}>
					{`${(getValues("Comments") || value)?.length ?? 0}/${maxLength} max.`}
				</span>
			)}
			{((getValues("Comments") || value)?.length as number) == maxLength && (
				<span style={{ marginLeft: 5, fontSize: 12, color: "#757575" }}>
					Max. {maxLength}
				</span>
			)}
		</>
	);
};
